export default __webpack_public_path__ + "static/testimonial1-86c6164f091a79d8d320d9edd2abc5db.png";